import React from 'react'
import { TextFieldSeeker } from '@ui-seeker/core'
import { object, string } from 'yup'
import { useAppFormHandler } from '@hooks'


export default function CarModelSelector() {

	const { model, onModelChange, error } = useAppFormHandler('model', object({ model: string().required('Must provide a model').max(1000) }))

	return <TextFieldSeeker
		label="Car Model"
		value={model || ''}
		error={error}
		onChange={e => onModelChange(e.target.value)}
	/>
}